// Original asset files are hosted on the live site. Direct binary download was
// blocked by the sandboxed tooling used to build this clone, so these images
// are referenced from their original hosted URLs. To make the app fully
// self-contained, download each file below and drop it into
// src/assets/images / src/assets/icons, then update the import paths here.

export const LOGO_MARK =
  "https://chanuka-alpha.vercel.app/assets/chanuka-a-De9pDdQk.svg";

export const FOOTER_MARK =
  "https://chanuka-alpha.vercel.app/assets/Chanuka-b-HbcR5UQX.svg";

export const APPLY_CARD_FLYER =
  "https://chanuka-alpha.vercel.app/assets/chanuka-kids-CcCt-tJh.png";

export const APPLY_CARD_PHOTO =
  "https://chanuka-alpha.vercel.app/assets/chanuka-students-9ppgBYhJ.png";
